module.exports = __webpack_public_path__ + "static/media/cusine.fb303294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cusine.svg
// module id = 385
// module chunks = 11